import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { LabelInterface, LabelTemplateInterface } from '../label';
import { from, Observable } from 'rxjs';
import { AssetInterface } from '../asset';
import { PlaceService, PlaceInterface } from '../place';
import { map, switchMap } from 'rxjs/operators';
import { SerialPrinterService } from '../printer/printer.service';

@Injectable({
  providedIn: 'root'
})
export class LabelService {

  public templatesChanged: EventEmitter<LabelTemplateInterface[]> = new EventEmitter<LabelTemplateInterface[]>();

  constructor(private http: HttpClient, private placeService: PlaceService, private printerService: SerialPrinterService) {
    this.loadLabelTemplates();
  }

  private _labelTemplates: LabelTemplateInterface[] = [];

  public currentLabelType = '25x70_25x17';

  assetToLabel(asset: AssetInterface): Observable<LabelInterface> {
    const label: LabelInterface = {
      id: asset._id,
      place: '',
      info: asset.hint,
      date: asset.aquisitionDate,
      type: this.currentLabelType
    };

    return this.placeService.get(asset._placeId).pipe(
      map((data) => {
        label.place = data.shorthandSymbol;
        return label;
      })
    );
  }

  getLabel(asset: AssetInterface, place: PlaceInterface): LabelInterface {
    const label: LabelInterface = {
      id: asset._id,
      place: place.shorthandSymbol,
      info: asset.hint,
      date: asset.aquisitionDate,
      type: this.currentLabelType
    };
    if (!label.id) {
      label.id = '?????';
    }
    return label;
  }

  getLabelTemplates(): LabelTemplateInterface[] {
    return this._labelTemplates;
  }

  loadLabelTemplates(): void {
    this.http.get<LabelTemplateInterface[]>('/api/labels/templates').subscribe(
      (data) => {
        this._labelTemplates = data;
      },
      (err) => {

      },
      () => {
        this.templatesChanged.emit(this._labelTemplates);
      }
    );
  }

  public generateEZPL(data: LabelInterface): string {
        
      const id = data.id.toString().padStart(5, '0');
      const date = (data.date.getMonth() + 1).toString().padStart(2, '0') + '.' + data.date.getFullYear().toString();

      const labelTemplate = this._labelTemplates.find((el) => {
          return el.name === data.type;
      });
      if (!labelTemplate || !labelTemplate.ezpl) {
          return '';
      }

      let ezpl = labelTemplate.ezpl.repeat(1);
      ezpl = ezpl.replace(/{{id}}/g, id);
      ezpl = ezpl.replace(/{{organisation1}}/g, 'MBG');
      ezpl = ezpl.replace(/{{organisation2}}/g, 'Espelkamp');
      ezpl = ezpl.replace(/{{place}}/g, data.place);
      ezpl = ezpl.replace(/{{date}}/g, date);
      ezpl = ezpl.replace(/{{info}}/g, data.info);
      ezpl = ezpl.replace(/{{info1}}/g, data.info);
      ezpl = ezpl.replace(/{{info2}}/g, data.info);
      
      return ezpl;
  }


  printLabel(label: LabelInterface): Observable<LabelInterface> {
    label.type = this.currentLabelType;
    const ezpl = this.generateEZPL(label);
    return from(this.printerService.printEZPL(ezpl)).pipe(
      map((data) => {
        return label;
      })
    );

    // return this.http.post<LabelInterface>('/api/labels/print', label);
  }

  printAsset(asset: AssetInterface): Observable<LabelInterface> {
    return this.assetToLabel(asset).pipe(
      switchMap((data) => this.printLabel(data))
    );
  }


}
